<small class="debug">{{me}}</small>
<!--<div cdkDropListGroup>-->
<!--  <div class="example-container">-->
<!--    <h2>Campaign list</h2>-->
<!--    <mat-list dense class="example-list"-->
<!--              cdkDropList-->
<!--              [cdkDropListData]="itemsFiltered"-->
<!--              cdkDropListSortingDisabled-->
<!--              (cdkDropListDropped)="drop($event)">-->
<!--      <mat-list-item class="example-box" *ngFor="let item of itemsFiltered" cdkDrag>-->
<!--        <mat-icon>reorder</mat-icon>-->
<!--        {{item}}-->
<!--      </mat-list-item>-->
<!--    </mat-list>-->
<!--  </div>-->
<!--  <div class="example-container">-->
<!--    <h2>Playlist hourlybalancer </h2>-->
<!--    <mat-list dense class="example-list"-->
<!--              cdkDropList-->
<!--              [cdkDropListData]="basket"-->
<!--              (cdkDropListDropped)="drop($event)">-->
<!--      <mat-list-item class="example-box" *ngFor="let item of basket" cdkDrag>{{item}}</mat-list-item>-->
<!--    </mat-list>-->
<!--  </div>-->
<!--</div>-->
<div cdkDropListGroup>
  <table mat-table id="bb" #dtable [dataSource]="destination" class="mat-elevation-z8 example-container drop-table-area"
    cdkDropList
    cdkDropListSortingDisabled
    [cdkDropListData]="destination"
    (cdkDropListDropped)="drop($event)">
    @for (col of displayedColumnsDestinationNoAction; track col) {
      <ng-container class="dragCursor" matColumnDef="{{col}}">
        <th mat-header-cell *matHeaderCellDef>{{col}}</th>
        <td mat-cell title="{{element[col]}}" class="textAlignLeft" *matCellDef="let element; let index = index">
          <editable (update)="updateField($event, col, element)">
            <ng-template viewMode>
              {{element[col] | PipeTruncate:[maxStringSize]}}
            </ng-template>
            <ng-template editMode>
              <input inputrestriction="basic1" style="width: 47px !important;" #editInput value="" focusable editableOnEnter>
            </ng-template>
          </editable>
        </td>
      </ng-container>
    }
    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button (click)="removeItem($event, element)" mat-icon-button aria-label="Example icon-button with a heart icon">
          <mat-icon style="color: red">block</mat-icon>
        </button>
      </td>
    </ng-container>
    <tr mat-header-row class="dragCursor textAlignLeft" *matHeaderRowDef="displayedColumnsDestinationAll"></tr>
    <tr mat-row class="dragCursor textAlignLeft" (mousedown)="selectedRowDestination(row)" *matRowDef="let row; columns: displayedColumnsDestinationAll;" cdkDrag [cdkDragData]="row"></tr>
  </table>
  <div class="drop-table-area">
    @if (this.destination && this.destination.length == 0) {
      <mat-label>
        <mat-icon>arrow_drop_up</mat-icon>
        {{'general.dragDropHere' | transloco}}
        <mat-icon>arrow_drop_up</mat-icon>
      </mat-label>
    }
  </div>
</div>
<mat-divider></mat-divider>
<mat-form-field class="example-form-field">
  <mat-label>{{placeholder}}</mat-label>
  <input #search id="search" matInput type="text" placeholder="{{placeholder}}" [(ngModel)]="valueInput">
  @if (valueInput) {
    <a matSuffix aria-label="Clear" (click)="reset()">
      <mat-icon>close</mat-icon>
    </a>
  }
</mat-form-field>
<div class="itemsFilteredTableWrap">
  <table mat-table id="aa" [dataSource]="itemsFiltered" class="mat-elevation-z8 example-container mat-column"
    cdkDropList
    [cdkDropListConnectedTo]="['bb']"
    [cdkDropListData]="itemsFiltered"
    cdkDropListSortingDisabled
    (cdkDropListDropped)="drop($event)">
    <ng-container matColumnDef="drag">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <mat-icon>unfold_more</mat-icon>
      </td>
    </ng-container>
    @for (col of displayedColumnsSourceNoDragIcon; track col) {
      <ng-container matColumnDef="{{col}}">
        <th mat-header-cell class="textAlignLeft" *matHeaderCellDef> {{col}}</th>
        <td mat-cell title="{{element[col]}}" class="textAlignLeft" *matCellDef="let element"> {{element[col] | PipeTruncate:[maxStringSize]}} </td>
      </ng-container>
    }
    <tr mat-header-row class="dragCursor" *matHeaderRowDef="displayedColumnsSourceAll"></tr>
    <tr mat-row cdkDrag class="dragCursor" (mousedown)="selectedRow(row)" *matRowDef="let row; columns: displayedColumnsSourceAll; "></tr>
  </table>
</div>


